import { GroupDivision } from "../../../shared/enums/GroupDivision";
import { StatusRefund } from "../../../shared/enums/StatusRefund";

export class PurchaseOrdersSearchFactory {
    companies: string[] = [];
    divisions: GroupDivision[] = [];
    months: string[] = [];
    customers: string[] = [];
    projects: string[] = [];
    statusPurchaseOrders: StatusRefund[] = [];
    skip: number = 0;
    limit: number = 10;
    isBlanketAgreement = false;
    totalItems: number = 0;
    filterAnticipation: boolean = true;

    newSearch(){
        let month = new Date().getMonth() - 1;
        let year = new Date().getFullYear();

        if (month == 11)
            year = year - 1;

        let search = {
            year:year,
            month:month,
            months:this.months,
            companies:this.companies,
            divisions:this.divisions,
            customers:this.customers,
            projects:this.projects,
            statusPurchaseOrders:this.statusPurchaseOrders,
            skip:this.skip,
            limit:this.limit,
            totalItems:this.totalItems,
            isBlanketAgreement: this.isBlanketAgreement,
            filterAnticipation: this.filterAnticipation
        };

        return search;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/factories/purchaseOrders/PurchaseOrdersSearch.factory.ts